module.exports = __webpack_public_path__ + "static/img/line-chart.615cd584.svg";